{
  "name": "plowops-dashboard",
  "version": "3.11.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-local": "ng serve --configuration local",
    "start-localtotest": "ng serve --configuration localtotest",
    "start-localtodev": "ng serve --configuration localtodev",
    "build": "ng build --configuration prod --base-href /dashboard/",
    "build-local": "ng build --configuration local",
    "build-dev": "ng build --configuration dev --base-href /",
    "build-test": "ng build --configuration test --base-href /",
    "build-prod": "ng build --configuration prod --base-href /",
    "watch": "ng build --watch --configuration dev",
    "format": "prettier --write \"src/**/*.{ts,html,css,scss,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,css,scss,json}\"",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix"
  },
  "private": true,
  "dependencies": {
    "@ali-hm/angular-tree-component": "^21.0.4",
    "@angular/animations": "^21.2.19",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.19",
    "@angular/compiler": "^21.2.19",
    "@angular/core": "^21.2.19",
    "@angular/forms": "^21.2.19",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.19",
    "@angular/platform-browser-dynamic": "^21.2.19",
    "@angular/router": "^21.2.19",
    "@arcgis/core": "^4.34.8",
    "@aws-amplify/ui-angular": "^5.3.5",
    "@esri/arcgis-rest-geocoding": "^4.10.3",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@sentry/angular": "^10.69.0",
    "@types/geojson": "^7946.0.16",
    "@types/sockjs-client": "^1.5.4",
    "@warren-bank/node-sortedlist": "^1.0.5",
    "angular-google-tag-manager": "1.13.0",
    "aws-amplify": "^6.20.0",
    "echarts": "^6.1.0",
    "file-saver-es": "^2.0.5",
    "geobuf": "^4.0.0",
    "hls.js": "^1.6.17",
    "maplibre-gl": "^5.24.0",
    "pmtiles": "^4.4.1",
    "moment": "^2.30.1",
    "ngx-color-picker": "^20.1.1",
    "ngx-colors": "^4.0.0",
    "ngx-echarts": "^21.0.0",
    "ngx-markdown": "^21.3.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "shpjs": "^6.2.0",
    "suncalc": "^1.9.0",
    "pako": "^2.2.0",
    "tslib": "^2.8.1",
    "turndown": "^7.2.4",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^21.1.0",
    "@angular-devkit/schematics": "^21.2.20",
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.20",
    "@angular/cli": "^21.2.20",
    "@angular/compiler-cli": "^21.2.19",
    "@angular/language-service": "^21.2.19",
    "@schematics/angular": "^21.2.20",
    "@sentry/esbuild-plugin": "^5.4.0",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~3.10.18",
    "@types/node": "^22.20.1",
    "@typescript-eslint/eslint-plugin": "^8.66.0",
    "@typescript-eslint/parser": "^8.66.0",
    "eslint": "^10.8.0",
    "eslint-config-prettier": "^10.1.8",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "prettier": "^3.9.6",
    "typescript": "~5.9.3"
  },
  "overrides": {}
}
